import { SubmissionError } from 'redux-form';

import { guestFields, companyFields } from './enums/Guest';

/**
 * Funkce rozhoduje o tom, zda je povolené tlačítko Pokračovat v navbaru.
 *
 * @param formValues
 * @param step
 * @param isPaymentGatewayEnabled
 * @returns {boolean}
 */
export function isContinueEnabled(formValues, step, isPaymentGatewayEnabled = false) {

	const isAtLeastOneRoomSelectedAndAtLeastOnePersonPerSelectedRoom = () => {
		let isAtLeastOneRoomSelected = false;

		for (let rooms of Object.values(formValues.rooms)) {
			if (!rooms || !rooms.length) continue;

			for (let room of rooms) {
				let isEmpty = true;
				for (let noOfGuests of Object.values(room.guestTypes)) {
					if (noOfGuests > 0) {
						isEmpty = false;
						isAtLeastOneRoomSelected = true;
						break;
					}
				}
				if (isEmpty) {
					return false;
				}
			}
		}

		return isAtLeastOneRoomSelected;
	};

	if (step === 1) {
		for (let rooms of Object.values(formValues.rooms)) {
			if (rooms.length) {
				return true;
			}
		}
		return false;
	}

	if (step === 2) {
		return isAtLeastOneRoomSelectedAndAtLeastOnePersonPerSelectedRoom();
	}

	if (step === 3) {
		return !validateStep3FormValues(formValues, false);
	}

	if (step === 4) {
		return isAtLeastOneRoomSelectedAndAtLeastOnePersonPerSelectedRoom() &&
			(!isPaymentGatewayEnabled || formValues.paymentMethod);

	}

	return false;
}

export function validateStep3FormValues(formValues, throwError = true)
{
	const errors = {};

	for (let field of guestFields) {
		if (field.required !== undefined && field.required === false) continue;

		if (!formValues[field.name] || !formValues[field.name].length) {
			errors[field.name] = [[field.label], ' ', ['validators.required']];

		} else {

			if (field.name === 'email' && !isEmailValid(formValues[field.name])) {
				errors[field.name] = 'validators.email';

			} else if (field.name === 'phone' && !isPhoneValid(formValues[field.name])) {
				errors[field.name] = 'validators.phone';
			}
		}
	}

	if (formValues.isCompany) {
		for (let field of companyFields) {
			if (field.required !== undefined && field.required === false) continue;

			if (!formValues[field.name] || (typeof formValues[field.name] === 'string' && !formValues[field.name].length)) {
				errors[field.name] = [[field.label], ' ', ['validators.required']];
			}
		}
	}

	if (throwError) {
		if (Object.keys(errors).length) {
			throw new SubmissionError(errors);
		}

	} else {
		return Object.keys(errors).length;
	}


}

export function isEmailValid(email) {
	const pattern = /^("([ !\x23-\x5B\x5D-\x7E]*|\\[ -~])+"|[-a-z0-9!#$%&'*+/=?^_`{|}~]+(\.[-a-z0-9!#$%&'*+/=?^_`{|}~]+)*)@([0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)+[a-z\u00C0-\u02FF\u0370-\u1EFF][-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF]$/i;

	return !!email.match(pattern);
}

export function isPhoneValid(phone) {
	const pattern = /^\+\d+$/;

	return !!phone.match(pattern);
}


// WEBPACK FOOTER //
// ./src/validators.js